import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.scss']
})
export class SpecialtiesComponent {

  specialities:any;
  speciality:any;
  isLoading: boolean = false;
 branch :any;
  params: any;
  hospitalId: any = "";
  allSpecialities: any;
  loading: boolean = true;
  allBranches: any;
  error:any = '';
  selectedHospitalName: any;
  isHospitalApp: any;
  hospitalIdStorage: any;

  currentPage: number = 1;
  itemsPerPage: number = 6;
  paginatedSpecialities: any[] = [];
  totalPages: number = 9;
  length = 0;
  pageSize = 6;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageEvent: PageEvent | any;


  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }


   // Updates pagination for displaying current page's doctors
   updatePagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedSpecialities = this.specialities.slice(startIndex, endIndex);
  }

  // Handles pagination events
  handlePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updatePagination();
  }



  constructor(private apiService: ApiService, private router: Router,
    private storage: StorageService, private spinner: NgxSpinnerService, private snackBar: MatSnackBar, private route: ActivatedRoute,) {

 }

 // Api call for getting hospital according to selected hospital id
 getSelectedHospital(hospitalId: string) {
  this.apiService.getHospital(hospitalId).subscribe({
    next: (response: any) => {
       if (response.success === true) {
         this.selectedHospitalName = response.data.name;
         
       }
     },
     error: (err: any) => {
       // hiding spinner
       this.spinner.hide();
      //  this.snackBar.open(err.error.message, '', {
      //    duration: 2000,
      //    horizontalPosition: 'center',
      //    verticalPosition: 'top',
      //    panelClass: 'text-center'
      //  });
      //  this.error = err.error.message;
     },
     complete: () => {
       // hiding spinner
       this.spinner.hide();
     }
   });
}


  // Fetch departments for the selected hospital
getDepartmentsForHospital(hospitalId: string) {
  this.spinner.show();
  this.apiService.getHospitalDepartments(hospitalId).subscribe({
   next: (response: any) => {
      if (response.success === true) {
        this.allSpecialities = response.data.data;
        this.specialities = [...this.allSpecialities];
        this.length = this.specialities.length;
        this.updatePagination();
        this.loading = false;
        // hiding spinner
        this.spinner.hide();
      }
    },
    error: (err: any) => {
      this.snackBar.open(err.error.message, '', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'text-center'
      });
      this.error = err.error.message;
      this.allBranches = [];
      // hiding spinner
      this.spinner.hide();
    },
    complete: () => {
      // hiding spinner
      this.spinner.hide();
    }
  });
}


 getAllDepartments() {
  // showing spinner
    this.spinner.show();
    this.apiService.getAllSpecialities().subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.specialities = response.data.data;
          this.length = this.specialities.length;
          this.updatePagination()
          // hiding spinner
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // hiding spinner
          this.spinner.hide();
        }
      },
      error: (err: any) => { 
        this.snackBar.open(err.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
        // hiding spinner
        this.spinner.hide();
       },
      complete: () => { 
        // hiding spinner
        this.spinner.hide();
      }
    });
  }

   // Function for storing speciality to get doctors according to speciality & navigating to doctors page
   gotoSpecialityDoctorsList(specialty?: any) {
    if(specialty){
      this.router.navigate(['/doctors', { specialtyId: specialty.id }]);
    }
  }

  ngOnInit(): void {   
    this.isHospitalApp = environment.isHospitalApp; 
    this.hospitalIdStorage = environment.hospitalId; 
    this.route.params.subscribe(params => {
      this.hospitalId = params['hospitalId'] ? params['hospitalId'] : '';
   });
   this.spinner.show();
   this.getSelectedHospital(this.hospitalId);
    if(this.hospitalId) {
      this.getDepartmentsForHospital(this.hospitalId)
    } else if(this.hospitalIdStorage) {
        this.getDepartmentsForHospital(this.hospitalIdStorage)
    }else {
      this.getAllDepartments()
    }
    
}

}
